export const parseAnswers = (answers: any) => {
  return Object.assign(
    {},
    ...answers.map((answer: any) => ({
      [`${answer.fieldId}`]: answer.value,
    }))
  );
}